import { atom, useAtom } from "jotai";
import { Partner } from "./usePartners/interfaces/Partner";

const selectedPartnerAtom = atom<Partner | undefined>(undefined);

export const useSelectedPartner = () => {
  const [selectedPartner, setSelectedPartner] = useAtom(selectedPartnerAtom);
  return { selectedPartner, setSelectedPartner };
};
